<template>
  <div class="modal-print-template" @click="closeModal">
    <div class="modal-content" @click.stop>
      <button class="close-button" @click="closeModal">×</button>
      <div class="modal-content-inner">
        <div class="modal-header">
          <h3>포트폴리오 크기 설정</h3>

        </div>

        <div class="templates-container">
          <div
              v-for="(template, index) in templates"
              :key="template.id"
              class="template-item"
              :class="{'selected': selectedTemplate === index,'locked': template.locked}"
              @click="!template.locked && selectTemplate(index)"
          >
            <img :src="template.img" class="template-image">
            <!--          <div class="template-info">-->
            <!--            <span class="template-name">{{ template.name }}</span>-->
            <!--            <span class="template-size">{{ template.size }}</span>-->
            <!--          </div>-->
          </div>
        </div>
      </div>
      <div class="modal-footer button-box">
        <button class="confirm-button" @click="confirmSelection">설정 완료</button>
      </div>

    </div>
  </div>
</template>

<script setup>
import {ref, onMounted, onBeforeUnmount, defineEmits} from 'vue';
import landscape_A4 from '@/assets/images/icon/landscape_A4.png';
import landscape_A5 from '@/assets/images/icon/landscape_A5.png';
import landscape_B5 from '@/assets/images/icon/landscape_B5.png';
import landscape_B6 from '@/assets/images/icon/landscape_B6.png';
import landscape_ppt from '@/assets/images/icon/landscape_ppt.png';
import portrait_A4 from '@/assets/images/icon/portrait_A4.png';
import portrait_A5 from '@/assets/images/icon/portrait_A5.png';
import portrait_B5 from '@/assets/images/icon/portrait_B5.png';
import portrait_B6 from '@/assets/images/icon/portrait_B6.png';
import portrait_ppt from '@/assets/images/icon/portrait_ppt.png';
import {useUiStore} from "@/store/useUiStore";

const uiStore = useUiStore();

const emit = defineEmits(['close', 'confirm']);

const selectedTemplate = ref(0); // 처음 선택 템플릿 지정

// locked true false는 클릭이벤트만 막음. 사용할거면 이미지도 변경 필요.
const rawTemplates = [
  {id: 1, name: 'A4/가로', size: [297, 210], img: landscape_A4, locked: false, orientation: 'landscape'},
  {id: 2, name: 'A5/가로', size: [210, 148], img: landscape_A5, locked: true, orientation: 'landscape'},
  {id: 3, name: 'B5/가로', size: [257, 182], img: landscape_B5, locked: true, orientation: 'landscape'},
  {id: 4, name: 'B6/가로', size: [182, 128], img: landscape_B6, locked: true, orientation: 'landscape'},
  {id: 5, name: '16:9', size: [297, 167], img: landscape_ppt, locked: true, orientation: 'landscape'},
  {id: 6, name: 'A4/세로', size: [210, 297], img: portrait_A4, locked: true, orientation: 'portrait'},
  {id: 7, name: 'A5/세로', size: [148, 210], img: portrait_A5, locked: true, orientation: 'portrait'},
  {id: 8, name: 'B5/세로', size: [182, 257], img: portrait_B5, locked: true, orientation: 'portrait'},
  {id: 9, name: 'B6/세로', size: [128, 182], img: portrait_B6, locked: true, orientation: 'portrait'},
  {id: 10, name: '9:16', size: [167, 297], img: portrait_ppt, locked: true, orientation: 'portrait'},
];

const templates = ref([]);
const screenWidth = ref(window.innerWidth);
const maxScreenWidth = 700; // css @media (max-width: 700px) 맞추기
const updateTemplates = () => {
  const original = rawTemplates;

  if (screenWidth.value < maxScreenWidth) {
    const colCount = 2;
    const rowCount = Math.ceil(original.length / colCount);
    const rearranged = [];

    for (let i = 0; i < rowCount; i++) {
      for (let j = 0; j < colCount; j++) {
        const index = i + j * rowCount;
        if (original[index]) {
          rearranged.push(original[index]);
        }
      }
    }
    templates.value = [...rearranged];
  } else {
    templates.value = [...original];
  }
};

const selectTemplate = (index) => {
  selectedTemplate.value = index;
};

const closeModal = () => {
  emit('close');
};

const confirmSelection = () => {
  emit('confirm', templates.value[selectedTemplate.value]);
  closeModal();
};

const handleResize = () => {
  screenWidth.value = window.innerWidth;
  updateTemplates();
};

onMounted(() => {
  updateTemplates();
  window.addEventListener("resize", handleResize);
  uiStore.showOverlay();
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", handleResize);
  uiStore.hideOverlay();
});
</script>

<style scoped>
.modal-print-template {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  display: flex;
  flex-direction: column;
}

.modal-content-inner {
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
  width: 100%;
  max-width: 854px;
  max-height: 70vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.close-button {
  background: none;
  border: none;
  font-size: 35px;
  cursor: pointer;
  color: white;
  display: flex;
  justify-content: flex-end;
}

.templates-container {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 12px;
}

@media (max-width: 700px) {
  .modal-content {
    width: 80%;
  }

  .templates-container {
    grid-template-columns: repeat(2, 1fr);
  }
}

.template-item {
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.template-item:hover {
  border-color: #ffc107;
  box-shadow: 0 0 5px rgba(255, 193, 7, 0.3);
}

.template-item.selected {
  border: 2px solid #ffc107;
  box-shadow: 0 0 8px rgba(255, 193, 7, 0.5);
}

.template-item.locked {
  cursor: not-allowed;
  pointer-events: auto; /* 클릭 이벤트는 명시적으로 막았기 때문에 남겨둠 */
}

.template-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.modal-footer {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}


/*
.template-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.template-name {
  font-weight: bold;
  font-size: 14px;
}

.template-size {
  font-size: 12px;
  color: #666;
}

.modal-footer {
  position: absolute;
  right: 0px;
  bottom: -47px;
}


.confirm-button {
  background-color: #ffc107;
  color: #000;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  cursor: pointer;
  font-weight: bold;
}

.confirm-button:hover {
  background-color: #ffb300;
}
*/


</style>